module.exports = __webpack_public_path__ + "img/1_1-piazza-1.725433e7.png";